import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AddButton } from "../micro/input";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../redux/common";

const Tab = ({
  tabs,
  btnClass,
  rightSide,
  btnDivClass,
  company,
  companyData,
}) => {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.tab.activeTab);
  const navigate = useNavigate();

  return (
    <div className="w-full">
      {company === "true" ? (
        <div className="flex justify-between items-center text-center">
          <p className="font-Montserrat text-xl font-normal mb-4">
            {companyData?.name}
          </p>
          {(activeTab === "Outlet" ||
            activeTab === "Equipments" ||
            activeTab === "Staff") && (
            <AddButton
              value={
                activeTab === "Outlet"
                  ? "Add Outlet"
                  : activeTab === "Equipments"
                  ? "Add Equipment"
                  : "Add Staff"
              }
              onClick={() =>
                navigate(
                  activeTab === "Outlet"
                    ? "/create-edit-outlet"
                    : activeTab === "Equipments"
                    ? "/create-edit-equipment"
                    : "/create-edit-staff",
                  { state: { mode: "create", companyData } }
                )
              }
            />
          )}
        </div>
      ) : null}
      <div className={`flex ${btnDivClass} ${rightSide ? "justify-end" : ""}`}>
        {tabs?.map((tab) => (
          <button
            key={tab.label}
            className={`py-2 px-4 uppercase text-[14px] border-b-2 transition duration-300 font-Proxima ${
              activeTab === tab.label
                ? "border-themeBtn text-themeBtn"
                : "border-transparent text-textSecondary hover:text-themeBtn"
            } ${btnClass}`}
            onClick={() => dispatch(setActiveTab(tab.label))}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div>{tabs?.map((tab) => activeTab === tab.label && tab.content)}</div>
    </div>
  );
};

export default Tab;
